import React from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { InjectedStyledComponent } from '../../../../../shared/index.js';
import Tooltip from '../../../Tooltip/Tooltip.js';
import { ITableEvents, TableColumnDisplayType } from '../../models/index.js';
import Superscript from '../../styledComponents/Superscript.js';
import CellValue from '../CellValue/CellValue.js';
import { TableComponentBase } from '../TableComponentBase.js';

import { ICellConfiguration, ICellProps, ICellState } from './models/index.js';
import { CELL_CATEGORY_KEY, CELL_COMPONENT_KEY, CELL_PARENT_COMPONENT_KEY } from './Cell.meta.js';

export class Cell extends TableComponentBase<
	ICellProps & React.TdHTMLAttributes<HTMLTableDataCellElement>,
	ICellState,
	ICellConfiguration
> {
	categoryKey = CELL_CATEGORY_KEY;
	componentKey = CELL_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return CELL_PARENT_COMPONENT_KEY;
	}
	get tableEventsKey(): keyof ITableEvents {
		return 'cell';
	}
	constructor(props: ICellProps) {
		super(props);

		makeObservable(this, {
			cellId: computed,
			shouldRenderSuperscript: computed,
		});
	}

	get cellId(): string {
		const { row, column } = this.props;
		return `${row._rowKey}_${column.id}`;
	}

	get shouldRenderSuperscript(): boolean {
		const { column } = this.props;

		return (
			!column.changeIndicatorProps &&
			(!column.display || column.display.type !== TableColumnDisplayType.changeIndicator)
		);
	}

	render() {
		const {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			children,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			configuration,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyle,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyleProps,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			table,

			cellValue,
			column,
			columnIndex,
			row,
			rowIndex,
			...otherProps
		} = this.props;
		const superscripts = this.table.logic.getCellSuperscripts(column, row);
		const tooltipProps = this.getTooltipRowProps(row, column);
		const events = this.getEvents(this.eventsForElement, row, rowIndex, column, columnIndex, cellValue);

		if (column && column.hideValue && column.hideValue(row, cellValue)) {
			return <td {...events} {...otherProps} />;
		}
		return (
			<td id={this.cellId} {...events} {...otherProps}>
				<CellValue table={this.table} cellValue={cellValue} column={column} />
				{this.shouldRenderSuperscript && superscripts && <Superscript>{superscripts.join(',')}</Superscript>}
				{tooltipProps && tooltipProps.map((props, index) => <Tooltip key={`tooltip_${index}`} {...props} />)}
			</td>
		);
	}
}

export default InjectedStyledComponent(observer(Cell), CELL_CATEGORY_KEY, CELL_PARENT_COMPONENT_KEY, [
	CELL_COMPONENT_KEY,
]);
